'use strict';
var utils = require('../components/utils');

/**
 * to show go to text message in case discount coupon are applied directly on cart
 * @param {string} show       flag to enable/disable gototext container
 * @param {Object} data       data object holding the content to append to the div container
 */
function toggleGoToContent(show, data) {
    if (show && data.content) {
        var html = utils.createModalMarkup(data.content, { title: 'Error' });
        var $modal = $(html).modal();

        // listen for events
        $modal
            .on('shown.bs.modal', function () {
            }).on('hide.bs.modal', function () {
            });
    } else {
        $('.promo-goto-link').remove();
        $('.promo-goto-text').remove();
        $('.promo-goto-text-container').addClass('d-none');
    }
}

/**
 * to show error message when CSRF issue is encountered in case discount coupon are applied on cart or checkout or discount program page
 * @param {string} show       flag to enable/disable gototext container
 * @param {Object} data       data object holding the alert content
 */
function toggleErrorOnCSRF(show, data) {
    const $promoCSRFErrorContainer = $('.js-promo-error-on-csrf-container');

    if (show && data.csrferror) {
        $promoCSRFErrorContainer.alert({
            content: data.csrferror,
            theme: 'danger',
            autoClose: false
        });
    } else {
        $promoCSRFErrorContainer.empty();
    }
}

module.exports = {
    toggleGoToContent: toggleGoToContent,
    toggleErrorOnCSRF: toggleErrorOnCSRF
};
